/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_auth_sign_up_subtitle = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get started with Toolverse for free`)
};

const es_auth_sign_up_subtitle = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comienza con Toolverse gratis`)
};

const de_auth_sign_up_subtitle = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Starte kostenlos mit Toolverse`)
};

const nl_auth_sign_up_subtitle = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Begin gratis met Toolverse`)
};

const fr_auth_sign_up_subtitle = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Démarrez gratuitement avec Toolverse`)
};

const it_auth_sign_up_subtitle = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inizia gratuitamente con Toolverse`)
};

const pt_br2_auth_sign_up_subtitle = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comece gratuitamente com a Toolverse`)
};

const pt_auth_sign_up_subtitle = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comece gratuitamente com a Toolverse`)
};

const ja_auth_sign_up_subtitle = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toolverseを無料で始めましょう`)
};

const zh_auth_sign_up_subtitle = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费开始使用Toolverse`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const auth_sign_up_subtitle = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.auth_sign_up_subtitle(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("auth_sign_up_subtitle", locale)
	if (locale === "en") return en_auth_sign_up_subtitle(inputs)
	if (locale === "es") return es_auth_sign_up_subtitle(inputs)
	if (locale === "de") return de_auth_sign_up_subtitle(inputs)
	if (locale === "nl") return nl_auth_sign_up_subtitle(inputs)
	if (locale === "fr") return fr_auth_sign_up_subtitle(inputs)
	if (locale === "it") return it_auth_sign_up_subtitle(inputs)
	if (locale === "pt-BR") return pt_br2_auth_sign_up_subtitle(inputs)
	if (locale === "pt") return pt_auth_sign_up_subtitle(inputs)
	if (locale === "ja") return ja_auth_sign_up_subtitle(inputs)
	return zh_auth_sign_up_subtitle(inputs)
};